import { z } from 'zod';
import { isoDateSchema, isWeekend, uuidSchema } from './common.js';
import { messengerSchema } from './funnel.js';
export const blockStateSchema = z.enum(['locked', 'available', 'completed']);
export const blockKindSchema = z.enum(['regular', 'final']);
export const submitTestSchema = z.object({
    answers: z
        .array(z.object({
        questionId: uuidSchema,
        optionId: uuidSchema,
    }))
        .min(1, 'Ответьте на вопросы'),
});
/**
 * Заявка на стажировку из итогового блока.
 * Дата обязана быть будним днём и не в прошлом — обе проверки повторяются
 * на сервере, здесь они нужны, чтобы подсветить поле сразу.
 */
export const internshipSchema = z.object({
    lastName: z.string().trim().min(1, 'Заполните поле').max(80),
    firstName: z.string().trim().min(1, 'Заполните поле').max(80),
    email: z.string().trim().toLowerCase().pipe(z.email('Проверьте адрес почты')),
    messenger: messengerSchema,
    messengerNick: z.string().trim().min(1, 'Укажите ник').max(80),
    scheduledDate: isoDateSchema.refine((value) => !isWeekend(value), 'Это выходной — выберите, пожалуйста, будний день (пн–пт)'),
});
/**
 * Тексты статусов по умолчанию. Перенесены из прототипа «соискатель»
 * и настраиваются администратором (требование A-11), поэтому лежат
 * в настройках, а здесь — только запасной вариант.
 */
export const DEFAULT_STATUS_TEXTS = {
    obuchenie: {
        headline: 'Ещё немного — и вы у цели 💪',
        instruction: 'Осталось совсем немного! Пройдите, пожалуйста, все блоки до конца — чем быстрее закончите, тем скорее сможем предложить вам ближайшую стажировку.',
        contact: 'Вопросы по материалам — руководителю обучения',
    },
    zapis: {
        headline: 'Заявка принята — ждём вас на стажировке',
        instruction: 'Заявка на стажировку получена. Стажировки стартуют только по будням. Если нужно перенести дату — просто напишите нам.',
        contact: 'Нужно перенести дату — напишите руководителю обучения',
    },
    stazhirovka: {
        headline: 'Стажировка идёт — вы почти на месте 🚀',
        instruction: 'Вы на стажировке — это последний рывок перед стартом! Всё получится, а мы рядом, если понадобится помощь.',
        contact: 'По рабочим вопросам — вашему руководителю',
    },
    linia: {
        headline: 'Вы вышли в линию',
        instruction: 'Теперь вы работаете на линии вместе с командой. Дальше — выход в штат.',
        contact: 'По рабочим вопросам — вашему руководителю',
    },
    shtat: {
        headline: 'Поздравляем с выходом в штат! 🎉',
        instruction: 'Поздравляем — вы в штате! Дальше всё самое интересное начинается по-настоящему.',
        contact: 'Все вопросы — вашему руководителю',
    },
    nedelya: {
        headline: 'Первая неделя позади',
        instruction: 'Вы отработали первую неделю — самый сложный этап уже пройден.',
        contact: 'Все вопросы — вашему руководителю',
    },
    vrabote: {
        headline: 'Вы в команде',
        instruction: 'Дальнейший путь мы ведём уже в общей системе компании.',
        contact: 'Все вопросы — вашему руководителю',
    },
    ushel: {
        headline: 'Процесс приостановлен',
        instruction: 'Если это ошибка или вы хотите вернуться — напишите нам.',
        contact: 'Свяжитесь с руководителем обучения',
    },
};
//# sourceMappingURL=course.js.map